import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router";
import {
  ActionButton,
  Text,
  Badge,
  LinkButton,
  mergeStyles,
} from "@react-spectrum/s2";
import ChatIcon from "@react-spectrum/s2/icons/Chat";
import RocketQuickActionsIcon from "@react-spectrum/s2/icons/RocketQuickActions";

import { Breadcrumbs } from "./Breadcrumbs";

// import HomeIcon from "@react-spectrum/s2/icons/Home";

import {
  style,
  css,
  size,
} from "@react-spectrum/s2/style" with { type: "macro" };
import { UserMenu } from "./UserMenu";

export const Header = ({ styles }) => {
  const navigate = useNavigate();

  return (
    <header
      className={mergeStyles(
        style({
          display: "grid",
          gridTemplateAreas: ["title content actions"],
          gridTemplateColumns: "1fr auto 1fr",
        }),
        styles,
      )}
    >
      <div
        className={style({
          gridArea: "title",
          display: "flex",
          alignItems: "center",
        })}
      >
        <ActionButton
          isQuiet
          onPress={() => navigate("/")}
          styles={style({
            gridArea: "title",
          })}
          UNSAFE_className={style({
            paddingStart: {
              default: 0,
              lg: 12,
            },
          })}
        >
          {/* <HomeIcon /> */}
          <Text
            styles={style({
              font: "title",
              display: "inline-flex",
              flexShrink: 0,
              alignItems: "center",
              gap: 8,
              marginEnd: -4,
            })}
          >
            BeStory
            <Badge
              size="XS"
              variant="magenta"
              UNSAFE_style={{ paddingInline: 2 }}
            >
              <RocketQuickActionsIcon />
            </Badge>
          </Text>
        </ActionButton>
        <Breadcrumbs />
        <div
          id="beStory-header-title"
          className={mergeStyles(
            css(`&:empty { display: none; }`),
            style({
              display: "flex",
              alignItems: "center",
              alignSelf: "stretch",
            }),
          )}
        />
      </div>
      <div
        id="beStory-header-content"
        className={style({
          gridArea: "content",
          display: "flex",
          flexGrow: 1,
          gap: 24,
          // gridTemplateAreas: ["title content actions"],
          // gridTemplateColumns: "1fr auto 1fr",
        })}
      />
      <div
        className={style({
          gridArea: "actions",
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginStart: "auto",
        })}
      >
        <div
          id="beStory-header-actions"
          className={style({
            display: "flex",
            alignItems: "center",
            gap: 12,
          })}
        />
        <LinkButton
          href="slack://channel?team=E23RE8G4F&id=C095CSV0N0Z"
          target="_blank"
          variant="secondary"
        >
          <ChatIcon />
          <Text>Community</Text>
        </LinkButton>
        <UserMenu />
      </div>
    </header>
  );
};

Header.propTypes = {
  styles: PropTypes.string,
};

export const HeaderTitle = ({ children }) => {
  const headerTitleContainer = document.getElementById("beStory-header-title");

  if (!headerTitleContainer) {
    console.warn(
      "HeaderTitle: Container element with id 'beStory-header-title' not found.",
    );
    return null;
  }

  return createPortal(children, headerTitleContainer);
};

HeaderTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export const HeaderContent = ({ children }) => {
  const headerContentContainer = document.getElementById(
    "beStory-header-content",
  );

  if (!headerContentContainer) {
    console.warn(
      "HeaderContent: Container element with id 'beStory-header-content' not found.",
    );
    return null;
  }

  return createPortal(children, headerContentContainer);
};

HeaderContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export const HeaderActions = ({ children }) => {
  const headerActionsContainer = document.getElementById(
    "beStory-header-actions",
  );

  if (!headerActionsContainer) {
    console.warn(
      "HeaderActions: Container element with id 'beStory-header-actions' not found.",
    );
    return null;
  }

  return createPortal(children, headerActionsContainer);
};

HeaderActions.propTypes = {
  children: PropTypes.node.isRequired,
};
